import React, { useState, useEffect } from 'react';
import { groupsService, screensService } from '../services/api';
import GroupModal from '../components/GroupModal';

function Groups({ user }) {
  const [groups, setGroups] = useState([]);
  const [screens, setScreens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingGroup, setEditingGroup] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [groupsRes, screensRes] = await Promise.all([
        groupsService.getAll(),
        screensService.getAll()
      ]);
      setGroups(groupsRes.data);
      setScreens(screensRes.data);
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setEditingGroup(null);
    setShowModal(true);
  };

  const handleEdit = (group) => {
    setEditingGroup(group);
    setShowModal(true);
  };

  const handleDelete = async (groupId) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer ce groupe ?')) {
      return;
    }

    try {
      await groupsService.delete(groupId);
      setMessage('Groupe supprimé');
      setTimeout(() => setMessage(''), 3000);
      loadData();
    } catch (error) {
      setMessage('' + (error.response?.data?.error || 'Erreur'));
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const handleSave = async (groupData) => {
    try {
      if (editingGroup) {
        await groupsService.update(editingGroup.id, groupData);
        setMessage('Groupe modifié');
      } else {
        await groupsService.create(groupData);
        setMessage('Groupe créé');
      }
      setTimeout(() => setMessage(''), 3000);
      setShowModal(false);
      loadData();
    } catch (error) {
      setMessage('' + (error.response?.data?.error || 'Erreur'));
      setTimeout(() => setMessage(''), 3000);
    }
  };

  const getScreensInGroup = (groupId) => {
    return screens.filter(s => s.group_id === groupId);
  };

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  return (
    <div className="groups-page">
      <div className="page-header">
        <h1>Gestion des groupes</h1>
        {user.role === 'admin' && (
          <button onClick={handleCreate} className="btn-secondary">
            Créer un groupe
          </button>
        )}
      </div>

      {message && <div className="message-banner">{message}</div>}

      <div className="groups-grid">
        {groups.map(group => (
          <div key={group.id} className="group-card">
            <div className="group-header">
              <h3>{group.name}</h3>
              <span className="screen-count">
                {getScreensInGroup(group.id).length} écran(s)
              </span>
            </div>

            {group.description && (
              <p className="group-description">{group.description}</p>
            )}

            <div className="group-screens">
              <h4>Écrans dans ce groupe :</h4>
              {getScreensInGroup(group.id).length > 0 ? (
                <ul className="screen-list">
                  {getScreensInGroup(group.id).map(screen => (
                    <li key={screen.id} className={screen.is_online ? 'online' : 'offline'}>
                      {screen.is_online ? '🟢' : '🔴'} {screen.name}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="empty-text">Aucun écran dans ce groupe</p>
              )}
            </div>

            {user.role === 'admin' && group.name !== 'Default' && (
              <div className="group-actions">
                <button onClick={() => handleEdit(group)} className="btn-edit">
                  ✏️ Modifier
                </button>
                <button onClick={() => handleDelete(group.id)} className="btn-delete">
                  🗑️ Supprimer
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      {groups.length === 0 && (
        <div className="empty-state">
          <p>Aucun groupe créé pour le moment.</p>
        </div>
      )}

      {showModal && (
        <GroupModal
          group={editingGroup}
          onSave={handleSave}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
}

export default Groups;
